export const LOGOUT = "app/LOGOUT";
export const CLEAR_REDUX_STORE = "app/CLEAR_REDUX_STORE";
